export default class CookiesModel {
    constructor() {
      this.pageData = {
        title: 'Kebijakan Penggunaan Kuki (Hanya Demo)',
        lastUpdated: this.getFormattedDate()
      };
    }
  
    getPageData() {
      return this.pageData;
    }
  
    getFormattedDate() {
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
        timeZone: 'Asia/Jakarta'
      };
      return new Date().toLocaleDateString('id-ID', options);
    }
  
    getPolicyContent() {
      return {
        sections: [
          {
            id: 'what-are-cookies',
            title: '1. Apa itu Kuki (Cookies)?',
            content: 'Kuki adalah file teks kecil yang disimpan di perangkat Anda ketika mengunjungi website. Kuki membantu kami mengingat preferensi Anda dan meningkatkan pengalaman penggunaan platform HeliaEDU.'
          },
          {
            id: 'types-of-cookies',
            title: '2. Jenis Kuki yang Kami Gunakan',
            subsections: [
              {
                title: '2.1 Kuki Esensial',
                content: 'Kuki yang diperlukan untuk fungsi dasar aplikasi:',
                list: [
                  'Token Autentikasi: Menyimpan status login pengguna',
                  'Preferensi Bahasa: Mengingat pilihan bahasa aplikasi',
                  'Pengaturan Keamanan: Melindungi dari serangan CSRF'
                ]
              },
              {
                title: '2.2 Kuki Preferensi',
                content: 'Kuki yang menyimpan pilihan dan pengaturan Anda:',
                list: [
                  'Tema Aplikasi: Mode terang atau gelap yang dipilih',
                  'Font Display: Preferensi font untuk aksesibilitas',
                  'Pengaturan Notifikasi: Status langganan push notification',
                  'Filter Konten: Preferensi tampilan konten'
                ]
              },
              {
                title: '2.3 Kuki Fungsional',
                content: 'Kuki yang mendukung fitur-fitur platform:',
                list: [
                  'Bookmark: Menyimpan daftar postingan yang disimpan',
                  'Lokasi Pengguna: Mengingat preferensi lokasi untuk fitur "Terdekat"',
                  'Riwayat Pencarian: Mempercepat pencarian berulang'
                ]
              }
            ]
          },
          {
            id: 'other-storage',
            title: '3. Teknologi Penyimpanan Lainnya',
            subsections: [
              {
                title: '3.1 Local Storage',
                content: 'Kami menggunakan localStorage untuk:',
                list: [
                  'Menyimpan data pengguna yang telah login',
                  'Cache konten untuk meningkatkan performa',
                  'Pengaturan aplikasi yang dipersonalisasi'
                ]
              },
              {
                title: '3.2 Session Storage',
                content: 'Digunakan untuk data sementara selama sesi browsing:',
                list: [
                  'Form data yang belum tersimpan',
                  'Status navigasi halaman',
                  'Data preview sebelum publikasi'
                ]
              }
            ]
          },
          {
            id: 'third-party',
            title: '4. Kuki Pihak Ketiga',
            content: 'Platform kami dapat menggunakan layanan pihak ketiga yang menempatkan kuki di perangkat Anda:',
            subsections: [
              {
                title: '4.1 Penyedia Peta',
                list: [
                  'MapTiler: Untuk layanan peta digital',
                  'Tujuan: Menampilkan peta dan geocoding',
                  'Data: Koordinat lokasi dan preferensi layer peta'
                ]
              },
              {
                title: '4.2 CDN dan Aset',
                list: [
                  'Google Fonts: Untuk font web',
                  'Material Icons: Untuk ikon aplikasi',
                  'Tujuan: Meningkatkan performa dan tampilan'
                ]
              }
            ]
          },
          {
            id: 'manage-cookies',
            title: '5. Mengelola Pengaturan Kuki',
            content: 'Anda dapat mengontrol kuki melalui pengaturan browser:',
            list: [
              'Memblokir semua kuki',
              'Menghapus kuki yang ada',
              'Mengatur notifikasi sebelum kuki disimpan',
              'Mengatur kuki berdasarkan website'
            ],
            note: 'Catatan: Menonaktifkan kuki esensial dapat memengaruhi fungsionalitas dasar aplikasi seperti login dan pengaturan preferensi.'
          },
          {
            id: 'security',
            title: '6. Keamanan dan Retensi',
            content: 'Semua data kuki dilindungi dengan enkripsi dan langkah-langkah keamanan yang sesuai. Data kuki akan dihapus secara otomatis sesuai dengan periode retensi yang ditetapkan atau ketika Anda menghapus data browser.'
          },
          {
            id: 'contact',
            title: '7. Kontak',
            content: 'Untuk pertanyaan tentang penggunaan kuki, hubungi kami:',
            contact: {
              email: 'nananghendystwn@gmail.com',
              name: 'Nanang Hendy S'
            }
          }
        ]
      };
    }
  }